import { useState } from "react";
import { Modal } from "react-bootstrap";

export const CountModal = ({ children, ...props }) => {
  const {
    modal = {
      header: {},
      footer: {},
      body: {},
      props: {},
    },
    count,
  } = props;
  const [open, setOpen] = useState(false);

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <a href="" onClick={handleOpen}>
        {children}

        {count && count > 1 ? ` +${count - 1}` : ""}
      </a>
      <Modal
        {...{
          size: "lg",
          centered: true,
          scrollable: true,
        }}
        {...modal.props}
        show={open}
        onHide={handleClose}
        scrollable
      >
        {modal.header && <Modal.Header {...modal.header} />}
        {modal.body && <Modal.Body {...modal.body} />}
        {modal.footer && <Modal.Footer {...modal.footer} />}
      </Modal>
    </>
  );
};
